import React, { Suspense, lazy } from "react";
import "./App.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Util/Loader/Loader";
// import Error from "./Util/Error/Error";

const Home = lazy(() => import(/* webpackChunkName: "Home"*/ "./Home/Home"));
const About = lazy(() => import("./About/About"));
const Membership = lazy(() => import("./Membership/Membership"));
const Structure = lazy(() => import("./Structure/Structure"));
const Mart = lazy(() => import("./Mart/Mart"));

const Directory = lazy(() => import("./Directory/Directory"));
const MemberProfile = lazy(() => import("./MemberProfile/MemberProfile"));
const Notification = lazy(() => import("./Notification/Notification"));
const Events = lazy(() => import("./Events/Events"));
const Releases = lazy(() => import("./Releases/Releases"));
const ContactUs = lazy(() => import("./ContactUs/ContactUs"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#002d3f",
    },
    secondary: {
      main: "#F1DEDF",
    },
  },
});

//
// GTag measurement ID

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            {/* <Header history={this.customHistory} /> */}
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/about" component={About} />
              <Route path="/membership" component={Membership} />
              <Route path="/structure" component={Structure} />
              <Route path="/vyapaar" component={Mart} />
              <Route path="/directory" component={Directory} />
              <Route path="/member/:memid" component={MemberProfile} />
              <Route path="/circulars" component={Notification} />
              <Route path="/events" component={Events} />
              <Route path="/releases" component={Releases} />
              <Route path="/contact" component={ContactUs} />
              {/* 404 Route */}
              <Route component={Home} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
